import Api from '@/repository/api'

import { IWarehouseTypesRepository } from '@/repository/warehouse/Types/WarehouseTypesRepository.types'
import StoreType from '@/entity/warehouse/Type/Warehouse.type'

import {
    IWarehouseTypes,
    WarehouseTypesResponseType
} from "@/entity/warehouse/Type/Warehouse.type.types";

export class WarehouseTypesRepository implements IWarehouseTypesRepository {
    async fetchAll(): Promise<IWarehouseTypes[]> {
        const response = await Api.get('/store/type/get');
        const responseData = response.data as WarehouseTypesResponseType[];
        return responseData.map((data: WarehouseTypesResponseType) => new StoreType(data));
    }
}
